<template>
  <v-card color="grey lighten-2" class="mb-12" :max-height="`${maxHeight}px`" style="overflow-y: auto">
    <div class="pa-2">
      <v-data-table
        v-model="_value"
        :headers="headers"
        :items="ferramentas"
        :single-select="false"
        item-key="id"
        show-select
        dense
        hide-default-footer
        disable-sort
        :items-per-page="-1"
        class="elevation-1 table-ferramentas-dados-perfis"
      />
    </div>
  </v-card>
</template>
<script>
  export default {
    props: {
      /* ferramentas seleconadas v-model */
      value: {
        type: Array,
        required: true
      },
      maxHeight: {
        type: Number,
        required: true
      },
      ferramentas: {
        type: Array,
        required: true
      }
    },

    emits: ['input'],

    data: () => ({
      headers: [{ text: 'Ferramentas', value: 'nome', align: 'start' }]
    }),

    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(newValue) {
          this.$emit('input', newValue);
        }
      }
    }
  };
</script>
<style>
  .table-ferramentas-dados-perfis table thead th {
    font-weight: 400 !important;
  }
</style>